import './travel-teaser.scss';

import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/scss';
import 'swiper/scss/navigation';
import 'swiper/scss/pagination';

class TravelTeaser {
    constructor (element) {
        this.$travelTeaser = element;
        this.slider = null;
        this.$$travelTeaserItems = this.$travelTeaser.querySelectorAll('.swiper-slide');
        this.$sliderContainer = this.$travelTeaser.querySelector('[data-travel-teaser="slider"]');
    }

    initialize () {
        this.initSlider();
    }

    initSlider () {
        if (this.$$travelTeaserItems.length > 1) {
            this.slider = new Swiper(this.$sliderContainer, {
                modules: [Navigation, Pagination],
                slidesPerView: 1,
                speed: 500,
                resistanceRatio: 0,
                autoHeight: false,
                pagination: {
                    el: '.swiper-pagination',
                    type: 'progressbar'
                },
                navigation: {
                    nextEl: this.$travelTeaser.querySelector('.slider__navigation-pagination-next'),
                    prevEl: this.$travelTeaser.querySelector('.slider__navigation-pagination-prev')
                }
            });
        }
    }
}

export { TravelTeaser };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$travelTeasers = $context.querySelectorAll('[data-travel-teaser="root"]');
        $$travelTeasers.forEach(($travelTeaser) => {
            const travelTeaser = new TravelTeaser($travelTeaser);
            travelTeaser.initialize();
        });
    }
});
